(function () {
  if (window.nycdVideoReady) return;
  window.nycdVideoReady = true;

  var modal;
  var frame;

  function build() {
    modal = document.createElement('dialog');
    modal.className = 'nycd-modal';
    modal.setAttribute('aria-label', 'Video');
    modal.innerHTML =
      '<button type="button" class="nycd-modal__close" aria-label="Close video">&times;</button>' +
      '<div class="nycd-modal__frame"></div>';
    document.body.appendChild(modal);
    frame = modal.querySelector('.nycd-modal__frame');
    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('.nycd-modal__close')) modal.close();
    });
    modal.addEventListener('close', function () {
      frame.replaceChildren();
    });
  }

  function player(url) {
    var youtube = url.match(/(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([\w-]{6,})/);
    var vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    var nbc = url.match(/nbcnews\.com\/.*?(\d{8,})(?:[?#]|$)/);
    if (nbc) url = 'https://www.nbcnews.com/news/embedded-video/mmvo' + nbc[1];
    var isFile = /\.(mp4|webm|mov|m4v|m3u8)(\?|$)/i.test(url);
    var element;
    if (youtube || vimeo || !isFile) {
      element = document.createElement('iframe');
      element.src = youtube
        ? 'https://www.youtube-nocookie.com/embed/' + youtube[1] + '?autoplay=1&rel=0&playsinline=1'
        : vimeo
          ? 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1'
          : url;
      element.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
      element.allowFullscreen = true;
      element.title = 'Video';
    } else {
      element = document.createElement('video');
      element.src = url;
      element.controls = true;
      element.autoplay = true;
      element.playsInline = true;
    }
    return element;
  }

  function initReviews() {
    document.querySelectorAll('.nycd-reviews').forEach(function (list) {
      list.classList.add('nycd-reviews--js');
      list.querySelectorAll('.nycd-review').forEach(function (card) {
        var text = card.querySelector('.nycd-review__text');
        if (text && !card.classList.contains('is-open')) {
          card.classList.toggle('has-more', text.scrollHeight > text.clientHeight + 2);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReviews);
  else initReviews();
  window.addEventListener('load', initReviews);
  window.addEventListener('resize', initReviews);
  document.addEventListener('shopify:section:load', initReviews);

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.nycd-reviews__toggle');
    if (toggle) {
      var list = toggle.previousElementSibling;
      if (list) list.classList.add('is-expanded');
      initReviews();
      return;
    }
    var more = event.target.closest('.nycd-review__more');
    if (more) {
      var card = more.closest('.nycd-review');
      var open = card.classList.toggle('is-open');
      more.textContent = open ? more.getAttribute('data-less') : more.getAttribute('data-more');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var trigger = event.target.closest('[data-nycd-video]');
    if (!trigger) return;
    var url = trigger.getAttribute('data-nycd-video');
    if (!url) return;
    if (!modal) build();
    if (typeof modal.showModal !== 'function') {
      window.open(url, '_blank', 'noopener');
      return;
    }
    frame.replaceChildren(player(url));
    modal.showModal();
  });
})();
